/*
 */

import Contactus from "../components/ContactUs/Contactus";

function ContactPage() {
  return (
    <>
      <Contactus></Contactus>
    </>
  );
}
export default ContactPage;
